import { useEffect, useState } from "react";
import { useAccessControl } from "@/hooks/useAccessControl";
import { AppLayout } from "@/components/layout/AppLayout";
import { PageHeader } from "@/components/layout/PageHeader";
import { PageContainer } from "@/components/layout/PageContainer";
import { Card } from "@/components/ui/card";
import { OpacPublicKeysSection } from "@/components/integrations/OpacPublicKeysSection";
import { fetchOpacIntegrationsConfig } from "@/lib/api/opac-applications";

const IntegrationsSettingsPage = () => {
  const { isTenantAdmin } = useAccessControl();
  const [config, setConfig] = useState<{
    opacKeySelfService: boolean;
    publicOpacPath: string;
  } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOpacIntegrationsConfig()
      .then(setConfig)
      .catch(() => setConfig({ opacKeySelfService: true, publicOpacPath: "/api/v1/public/opac" }))
      .finally(() => setLoading(false));
  }, []);

  if (!isTenantAdmin) {
    return (
      <AppLayout>
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4">Access Denied</h2>
            <p className="text-gray-600">You need Tenant Admin permissions to access this page.</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <PageContainer>
        <PageHeader
          title="Integrations"
          description="Connect external library websites to your catalog, journals, digital resources, and live availability."
          breadcrumbItems={[{ label: "Setup", href: "/setup" }, { label: "Integrations" }]}
          showSearch={false}
          titleSize="md"
        />

        <Card className="p-6">
          {loading || !config ? (
            <p className="text-sm text-gray-500">Loading integration settings...</p>
          ) : (
            <OpacPublicKeysSection
              selfServiceEnabled={config.opacKeySelfService}
              publicOpacPath={config.publicOpacPath}
            />
          )}
        </Card>
      </PageContainer>
    </AppLayout>
  );
};

export default IntegrationsSettingsPage;
